/* assets/product-details-drawer.js */
(() => {
  const DURATION = 650;                                // adjust speed (ms)
  const EASE     = 'cubic-bezier(0.16,0.84,0.44,1)';   // adjust easing
  const supportsWAAPI = 'animate' in Element.prototype;
  const prefersReduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const lockScroll = (on) => {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };

  async function openDrawer(drawer) {
    const overlay = drawer.querySelector('.pdp-drawer__overlay');
    const panel   = drawer.querySelector('.pdp-drawer__panel');

    // 1) Make it visible per your CSS
    drawer.classList.add('is-open');
    lockScroll(true);

    // 2) Set start states to override .is-open CSS (overlay would otherwise jump to 1)
    overlay.style.opacity = '0';
    panel.style.transform = 'translateX(100%)';

    if (!supportsWAAPI || prefersReduce) {
      // No animation support — snap to end
      overlay.style.opacity = '1';
      panel.style.transform = 'translateX(0)';
      return;
    }

    // 3) Animate
    overlay.animate([{opacity:0},{opacity:1}], {
      duration: Math.max(250, DURATION - 150),
      easing: 'linear',
      fill: 'forwards'
    });

    await panel.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}], {
      duration: DURATION,
      easing: EASE,
      fill: 'forwards'
    }).finished;
  }

  async function closeDrawer(drawer) {
    const overlay = drawer.querySelector('.pdp-drawer__overlay');
    const panel   = drawer.querySelector('.pdp-drawer__panel');

    if (!supportsWAAPI || prefersReduce) {
      drawer.classList.remove('is-open');
      overlay.style.opacity = '';
      panel.style.transform = '';
      lockScroll(false);
      return;
    }

    overlay.animate([{opacity:1},{opacity:0}], {
      duration: Math.max(200, DURATION - 200),
      easing: 'linear',
      fill: 'forwards'
    });

    await panel.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}], {
      duration: DURATION,
      easing: EASE,
      fill: 'forwards'
    }).finished;

    // Cleanup and actually hide
    drawer.classList.remove('is-open');
    overlay.style.opacity = '';
    panel.style.transform = '';
    lockScroll(false);
  }

  // Click handlers (use your existing data attributes)
  document.addEventListener('click', (e) => {
    const openBtn  = e.target.closest('[data-drawer-open]');
    const closeBtn = e.target.closest('[data-drawer-close]');
    const isOverlay = e.target.classList?.contains('pdp-drawer__overlay');

    if (openBtn) {
      const drawer = document.getElementById(openBtn.getAttribute('data-drawer-open'));
      if (drawer && !drawer.classList.contains('is-animating')) {
        openDrawer(drawer);
      }
    }
    if (closeBtn || isOverlay) {
      const drawer = e.target.closest('.pdp-drawer');
      if (drawer) closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const open = document.querySelector('.pdp-drawer.is-open');
      if (open) closeDrawer(open);
    }
  });
})();

// WALLPAPER CALCULATOR
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.wallpaper-calculator__form');
  if (!form) return;

  // Product sizes
  const panelWidthLabel = '25"'; // display only
  const panelHeightsInches = [48, 60, 72, 96, 108, 120].sort((a,b) => a-b);
  const maxPanelHeight = Math.max.apply(null, panelHeightsInches);

  // Customer rule: add 3" to height for trimming
  const trimAllowanceInches = 0;

  // Customer width table matches ceil(width / 25)
  const effectiveCoveragePerPanel = 25;

  const resultEl = form.querySelector('.wallpaper-calculator__result');

  function normalizeFeetInches(feetRaw, inchesRaw) {
    const feet = (parseFloat(feetRaw) || 0);
    const inches = (parseFloat(inchesRaw) || 0);

    // Allow total inches (e.g. 150") and normalize
    const normalizedFeet = feet + Math.floor(inches / 12);
    const normalizedInches = inches % 12;

    return {
      totalInches: (normalizedFeet * 12) + normalizedInches
    };
  }

  function choosePanelHeight(requiredHeightInches) {
    // smallest available height >= required height
    for (const h of panelHeightsInches) {
      if (h >= requiredHeightInches) return h;
    }
    // if taller than max, we will stack max height
    return maxPanelHeight;
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Read + normalize
    const wallWidth = normalizeFeetInches(form.width_feet.value, form.width_inches.value).totalInches;
    const wallHeight = normalizeFeetInches(form.height_feet.value, form.height_inches.value).totalInches;

    if (wallWidth <= 0 || wallHeight <= 0) {
      resultEl.textContent = 'Please enter your wall size using feet, inches, or both.';
      return;
    }

    // Apply +3" trim allowance to height
    const requiredHeight = wallHeight + trimAllowanceInches;
// If height is more than 120", show custom message (no stacking)
if (requiredHeight > maxPanelHeight) {
  resultEl.textContent =
    'Your wall will need a custom panel height, please reach out to us for a quote.';
  return;
}
    // Panels across using customer ranges (via effective 24.75" coverage)
    let panelsAcross = Math.ceil(wallWidth / effectiveCoveragePerPanel);

    // If you want to strictly follow their provided chart max (15 panels up to 372")
    if (panelsAcross > 15) {
      resultEl.textContent =
        'Your wall width is beyond our calculator range. Please contact us for a custom quote.';
      return;
    }

    // Height selection + stacking logic
    const chosenHeight = choosePanelHeight(requiredHeight);
    const dropsPerColumn = requiredHeight > maxPanelHeight
      ? Math.ceil(requiredHeight / maxPanelHeight)
      : 1;

    const totalPanels = panelsAcross * dropsPerColumn;

    const sizeLabel = `${panelWidthLabel} wide × ${chosenHeight}" high`;

    if (requiredHeight > maxPanelHeight) {
      resultEl.textContent =
       // `Includes ${trimAllowanceInches}" extra height for trimming. ` +
        `Each column will use ${dropsPerColumn} stacked panels. ` +
        `You’ll need ${totalPanels} panel${totalPanels === 1 ? '' : 's'} of ${sizeLabel}.`;
    } else {
      resultEl.textContent =
      //  `Includes ${trimAllowanceInches}" extra height for trimming. ` +
        `You’ll need ${totalPanels} panel${totalPanels === 1 ? '' : 's'} of ${sizeLabel}.`;
    }
  });

  // RESET BUTTON
  const resetBtn = form.querySelector('.wallpaper-calculator__reset');
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      form.reset();
      resultEl.textContent = '';
    });
  }
});
